import React from 'react';
import {ProgressSpinner} from "primereact/progressspinner";
import "./Loading.css";

const Loading = () => {

    return (
        <div id="loadingIlearning" className="loadingIlearning">
            <div className="loading">

            </div>
            <div className="loadingContent">
                <div className="spinner">
                    <ProgressSpinner style={{width: '60px', height: '60px'}} strokeWidth="6"/>
                </div>
            </div>
        </div>
    );
}
export default Loading;